module.exports = function() {
  return new Worker(__webpack_public_path__ + "af2ae51a5a0cac98ac95.worker.js");
};